/**
 * German VAT (MwSt./Umsatzsteuer) rate constants.
 *
 * Valid rates per §12 UStG: 19% standard (Regelsteuersatz), 0% exempt.
 */

export const GERMAN_VAT_OPTIONS = [
	{ label: "0%", value: 0 },
	{ label: "19%", value: 19 },
];

export const VALID_GERMAN_VAT_RATES = [0, 19];

export const DEFAULT_GERMAN_VAT_RATE = 19;

// Legacy aliases kept for backward compatibility
export const DEFAULT_VAT_PERCENTAGE = DEFAULT_GERMAN_VAT_RATE;
export const VAT_OPTIONS = GERMAN_VAT_OPTIONS;
